import { createSlice } from "@reduxjs/toolkit";
import socketFactory from "../../../utils/socketFactory";

const raisedHandsSlice = createSlice({
  name: "raisedHands",
  initialState: {
    list: []
  },
  reducers: {
    raiseHand: (state, action) => {
      const exists = state.list.find(r => r.sender === action.payload.sender);
      if (!exists) state.list.push(action.payload);
    },

    lowerHand: (state, action) => {
      state.list = state.list.filter(r => r.sender !== action.payload);
    },

   RECEIVE_RAISE_HAND: (state, action) => {
  const { sender, senderEmail, senderName, time } = action.payload;

  const exists = state.list.some(
    r => r.sender === sender || r.senderEmail === senderEmail
  );

  if (!exists) {
    state.list.push({
      sender,        
      senderEmail,   
      senderName,
      time
    });
  }
},
    RECEIVE_LOWER_HAND: (state, action) => {
  state.list = state.list.filter(
    r => r.sender !== action.payload && r.senderEmail !== action.payload
  );
},
    CLEAR_HANDS: (state) => {
      state.list = [];
},

  }
});

export const {
  raiseHand,
  lowerHand,
  RECEIVE_RAISE_HAND,
  RECEIVE_LOWER_HAND,
  CLEAR_HANDS,
} = raisedHandsSlice.actions;

export const RAISE_HAND_TO_ROOM = socketFactory.emit(
  "raiseHandToRoom",
  "socket/raiseHandToRoom"
);

export const LOWER_HAND_TO_ROOM = socketFactory.emit(
  "lowerHandToRoom",
  "socket/lowerHandToRoom"
);

export default raisedHandsSlice.reducer;
